export default "__VITE_ASSET__6a39873c__"